import { Editor, StandardInlineToolbar, StandardSideToolbar } from "../..";
import React, { Fragment } from "react";

export default function EditorWithToolbars(props) {
  return (
    <Editor {...props}>
      {({ editorKey, editorState, focus, focusEditor, onChange }) => (
        <>
          <StandardSideToolbar
            focus={focus}
            editorKey={editorKey}
            editorState={editorState}
            focusEditor={focusEditor}
            onChange={onChange}
          />

          <StandardInlineToolbar editorState={editorState} focusEditor={focusEditor} onChange={onChange} />
        </>
      )}
    </Editor>
  );
}
